import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExceptionService, UtilsService } from './../../../xform-compat';
import { RmsBasicCrudService } from '../../components/rms-basic-crud.service';
import { CompanyChart, FairValueHistoryPoint } from '../../../shared/models';


/**
 * Injectable service to handle chart data from the BE
 */
@Injectable()
export class CompanyChartService extends RmsBasicCrudService<any> {

  constructor(
    http: HttpClient,
    utilsService: UtilsService,
    exceptionService: ExceptionService
  ) {
    super(http, utilsService, exceptionService);
  }

  /**
   * Gets Market Cap and Stock company chart data
   * @param {number} companyId
   * @param params
   * @returns {Observable<CompanyChart>}
   */
  public getChartData (companyId: number, params?: any): Observable<CompanyChart> {
    return super.getData(`/api/rms/companies/${companyId}/historychart`, params);
  }

  /**
   * Gets the company's effective fair value history (FAIR or CALCULATED_FAIR), oldest first
   * @param {number} companyId
   * @returns {Observable<Array<FairValueHistoryPoint>>}
   */
  public getFairValueHistory (companyId: number): Observable<Array<FairValueHistoryPoint>> {
    return super.getData(`/api/rms/companies/${companyId}/financials/priceTargets/fairValueHistory`);
  }

}
